import React, { useContext, useMemo } from 'react'

import { PageDataContextType } from '../types/page'

type PageDataType = Partial<PageDataContextType>
export const PageDataContext = React.createContext<PageDataType>({})

export default function usePageData(): PageDataType {
  return useContext(PageDataContext) as PageDataType
}

export const PageDataProvider: React.FC<PageDataContextType> = ({
  children,
  ...data
}) => {
  // This data shouldn't change between renders as it's coming from Gatsby's
  // page data.
  const memoizedData = useMemo(
    () => data,
    /* eslint-disable-next-line */
    []
  )

  return (
    <PageDataContext.Provider value={memoizedData}>
      {children}
    </PageDataContext.Provider>
  )
}

PageDataProvider.displayName = 'PageDataProvider'
